import { type FC } from 'react'

export const Card: FC<{ className?: string }> = ({ children, className = '' }) => {
  return <section className={`p-6 bg-white border rounded shadow-lg border-mtd-gray-100 text-mtd-gray-700 ${className}`}>
    {children}
  </section>
}
